import React, { Fragment } from "react";
import { InputWrapper } from "../../parts/input-wrapper/InputWrapper";
import { FieldModel } from "../../shared/model/field-model";

export interface ForgotPasswordCodeFieldSetProps {
  pageName: string;
  codeState: FieldModel;
  onCodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onCodeBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  passwordState: FieldModel;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  confirmPasswordState: FieldModel;
  onConfirmPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onConfirmPasswordBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
}
export const ConfirmForgotPasswordCodeFieldSet = (props: ForgotPasswordCodeFieldSetProps) => {
  const { pageName, codeState, onCodeChange, onCodeBlur } = props;
  const { passwordState, onPasswordChange, onPasswordBlur } = props;
  const { confirmPasswordState, onConfirmPasswordChange, onConfirmPasswordBlur } = props;
  return (
    <Fragment>
      <InputWrapper
        pageName={pageName}
        name="code"
        caption="Code"
        fieldState={codeState}
        shouldDisplayRequired
        inputType="text"
        autoCompleteType=""
        onInputChange={onCodeChange}
        onInputBlur={onCodeBlur}
      />
      <InputWrapper
        pageName={pageName}
        name="create_password"
        caption="New Password"
        inputType="password"
        autoCompleteType="new-password"
        fieldState={passwordState}
        shouldDisplayRequired
        onInputChange={onPasswordChange}
        onInputBlur={onPasswordBlur}
      />
      <InputWrapper
        pageName={pageName}
        name="confirm_password"
        caption="Enter New Password Again"
        inputType="password"
        autoCompleteType="new-password"
        fieldState={confirmPasswordState}
        shouldDisplayRequired
        onInputChange={onConfirmPasswordChange}
        onInputBlur={onConfirmPasswordBlur}
      />
    </Fragment>
  );
};
